export default __webpack_public_path__ + "static/media/tip3Right.c0efbfc5.svg";